<template>
  <div>
    <Modal
      title="Logs da Integração "
      :active.sync="active"
      id="popup-integration-logs"
    >
      <vs-tabs alignment="center" v-model="activeTab">
        <vs-tab label="STAR" class="mt-4">
          <StarIntegrationContent
            :logs="syncStarLogs"
            :policy-id="policyId"
            :policyType="policyType"
            :integrationsStatus="integrationsStatus"
            @reload="getLogsStar"
          />
        </vs-tab>
        <vs-tab label="Maxpar Vidros" class="mt-4">
          <MaxparIntegrationContent
            :logs="syncMaxparGlassLogs"
            :policy-id="policyId"
            :integrationsStatus="integrationsStatus"
            @reload="getLogsMaxparGlass"
          />
        </vs-tab>
        <vs-tab label="Maxpar Assistência" class="mt-4">
          <MaxparAssistanceIntegrationContent
            :logs="syncMaxparAssistanceLogs"
            :policy-id="policyId"
            :integrationsStatus="integrationsStatus"
            @reload="getLogsMaxparAssistance"
          />
        </vs-tab>
        <vs-tab label="Veniti" class="mt-4">
          <VenitiIntegrationContent
            :data="syncVenitiData"
            :policy-id="policyId"
            :reload="loadVenitiLogs"
          />
        </vs-tab>
      </vs-tabs>
    </Modal>
  </div>
</template>

<script>
import StarIntegrationContent from './contents/StarIntegrationContent';
import MaxparIntegrationContent from './contents/MaxparIntegrationContent.vue';
import MaxparAssistanceIntegrationContent from './contents/MaxparAssistanceIntegrationContent.vue';
import notify from '../../../utils/notify';
import VenitiIntegrationContent from './contents/VenitiIntegrationContent.vue';
import venitiApiService from '../../../services/veniti.api';
import starApiService from '../../../services/star.api';
import maxparApiService from '../../../services/maxpar.api';
import Modal from '../../../components/Modal.vue';

export default {
  name: 'ModalIntegrationLogs',
  props: ['policyId', 'integrationsStatus', 'policyType'],
  components: {
    MaxparIntegrationContent,
    MaxparAssistanceIntegrationContent,
    VenitiIntegrationContent,
    StarIntegrationContent,
    Modal,
  },
  data() {
    return {
      active: false,
      activeTab: 0,
      syncStarLogs: [],
      syncMaxparGlassLogs: [],
      syncMaxparAssistanceLogs: [],
      syncVenitiData: {},
    };
  },
  methods: {
    openModal() {
      this.getLogs();
      this.active = true;
    },
    async getLogs() {
      try {
        const promises = [
          await starApiService.getLogsByPolicyId(this.policyId),
          await maxparApiService.getGlassLogsByPolicyId(this.policyId),
          await maxparApiService.getAssistanceLogsByPolicyId(this.policyId),
          await venitiApiService.getLogsByPolicyId(this.policyId),
        ];
        const [syncStar, syncMaxparGlass, syncMaxparAssistance, syncVeniti] =
          await Promise.all(promises);
        this.syncStarLogs = syncStar;
        this.syncMaxparGlassLogs = syncMaxparGlass;
        this.syncMaxparAssistanceLogs = syncMaxparAssistance;
        this.syncVenitiData = syncVeniti;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },

    async getLogsStar() {
      this.$vs.loading();
      try {
        this.syncStarLogs = await starApiService.getLogsByPolicyId(
          this.policyId,
        );
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async getLogsMaxparGlass() {
      this.$vs.loading();
      try {
        this.syncMaxparGlassLogs =
          await maxparApiService.getGlassLogsByPolicyId(this.policyId);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async getLogsMaxparAssistance() {
      this.$vs.loading();
      try {
        this.syncMaxparAssistanceLogs =
          await maxparApiService.getAssistanceLogsByPolicyId(this.policyId);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async loadVenitiLogs() {
      this.$vs.loading();
      try {
        this.syncVenitiData = await venitiApiService.getLogsByPolicyId(
          this.policyId,
        );
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>

<style>
#popup-integration-logs.con-vs-popup .vs-popup {
  min-width: 960px;
}
</style>
